import {
  FormField,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import type { Queue } from 'lib-shared-types-api';
import { useCallback, useState } from 'react';

import { appActions } from 'app/app.actions';
import { InputQueuesSelect } from 'components/inputQueuesSelect';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import styles from './conversationQueueTransferModal.module.scss';

/** A component for transferring a conversation to a different queue. */
export const ConversationQueueTransferModal = createAppModal(
  { type: 'app:conversationQueueTransfer' },
  ({ isOpen, modal, hide }): JSX.Element => {
    const dispatch = useAppDispatch();
    const [selectedQueues, setSelectedQueues] = useState<Queue[]>([]);
    const queue: Queue | undefined = selectedQueues[0];
    const csid = modal.arg.csid;

    /** Handles closing the transfer to queue modal. */
    const handleClose = useCallback(() => {
      ampli.modalTransferToQueueCancelClicked();
      hide?.();
    }, [hide]);

    /** Handles confirming the transfer to queue. */
    const handleConfirm = useCallback(async () => {
      if (!csid || !queue) {
        return;
      }

      ampli.modalTransferToQueueConfirmClicked({
        csid,
        queueId: queue.id,
      });

      dispatch(
        appActions.conversationTransferRequest.pending({
          request: {
            type: 'internal_queue',
            csid,
            queue,
          },
        }),
      );

      handleClose();
    }, [csid, dispatch, handleClose, queue]);

    return (
      <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
        <ModalHead
          title={`Transfer ${csid} to a different queue`}
          onClose={handleClose}
        />

        <ModalBody>
          <FormField>
            <InputQueuesSelect
              value={selectedQueues}
              onChange={({ selectedValues }) =>
                setSelectedQueues(selectedValues)
              }
            />
          </FormField>
        </ModalBody>

        <ModalFoot
          cancelOnClick={handleClose}
          confirmName="Transfer"
          confirmProps={{
            disabled: !queue,
          }}
          confirmOnClick={handleConfirm}
        />
      </Modal>
    );
  },
);
